import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import {Store} from '@ngxs/store';
import {UserState} from '../../shared/user-state/user.state';
import {Router} from '@angular/router';
import {UserStateActions} from '../../shared/user-state/user-state.actions';


export const CustomHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const router = inject(Router);

  let authReq = null;
  const token = store.selectSnapshot(UserState.accessToken);
  if (token) {
    // Clone the request and add the authorization header
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  } else {
    authReq = req.clone();
  }

  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        // Handle HTTP errors
        if (err.status === 401) {
          // Specific handling for unauthorized errors
          // alertService.display('error', "Unauthorized request");
          // authService.triggerLogin();
          // authService.reset();
          store.dispatch(new UserStateActions.DeleteTokens());
          router.navigateByUrl('/login');
        } else {
          // Handle other HTTP error codes
          // alertService.display('error', "An error has occured");
          alert(err.message);
        }
      } else {
        // Handle non-HTTP errors
        // alertService.display('error', "An unknown error has occured");
        alert(err.message);
      }

      // Re-throw the error to propagate it further
      return throwError(() => err);
    }),
  );
};
